const questions = [
  "I am the life of the party",
  "I feel little concern for others",
  "I am always prepared",
  "I get stressed out easily",
  "I have a rich vocabulary",
  "I don't talk a lot",
  "I am interested in people",
  "I leave my belongings around",
  "I am relaxed most of the time",
  "I have difficulty understanding abstract ideas",
  "I feel comfortable around people",
  "I insult other people",
  "I pay attention to details",
  "I worry about things",
  "I have a vivid imagination",
  "I keep in the background",
  "I sympathize with other people's feelings",
  "I make a mess of things",
  "I seldom feel blue",
  "I am not interested in abstract ideas",
  "I start conversations",
  "I am not interested in other people's problems",
  "I get chores done right away",
  "I am easily disturbed",
  "I have excellent ideas",
  "I have little to say",
  "I have a soft heart",
  "I often forget to put things back in their proper place",
  "I get upset easily",
  "I do not have a good imagination",
  "I talk to a lot of different people at parties",
  "I am not really interested in others",
  "I like order",
  "I change my mood a lot",
  "I am quick to understand things",
  "I don't like to draw attention to myself",
  "I take time out for others",
  "I shirk my duties",
  "I have frequent mood swings",
  "I use difficult words",
  "I don't mind being the center of attention",
  "I feel other people's emotions",
  "I follow a schedule",
  "I get irritated easily",
  "I spend time reflecting on things",
  "I am quiet around strangers",
  "I make people feel at ease",
  "I am exacting in my work",
  "I often feel blue",
  "I am full of ideas",
];

const domainData = [
  {
    key: 1,
    domainName: "Openness to Experience",
    desc:
      "Openness to experience, or simply openness, is a basic personality trait denoting receptivity to new ideas and new experiences.",
    traits:
      "Active Imagination, Aesthetic Sensitivity, Attentiveness to Inner Feelings, Preference for Variety, and Intellectual Curiosity",
  },
  {
    key: 2,
    domainName: "Conscientiousness",
    desc:
      "Conscientiousness is the personality trait of being careful, or diligent. Conscientiousness implies a desire to do a task well, and to take obligations to others seriously.",
    traits: "Self-Efficacy, Orderliness, Dutifulness, Ambition, Self-Discipline",
  },
  {
    key: 3,
    domainName: "Extraversion",
    desc:
      "Extraversion is defined by the general tendency to experience positive emotions, as well as by traits such as sociable, lively, and active.",
    traits: "Sociability, Assertiveness, Activity Level, Positive Emotions, Impulsivity",
  },
  {
    key: 4,
    domainName: "Agreeableness",
    desc:
      "Overall, agreeableness describes a person's ability to put other people's needs above their own.",
    traits: "Friendliness, Cooperation, Trust, Warmth, Altruism",
  },
  {
    key: 5,
    domainName: "Neuroticism",
    desc:
      "A neurotic personality is characterised by persistent, often disproportionate, worrying and anxiety.",
    traits: "Nervousness, Anxiety, Self-Doubt, Vulnerability, Moodiness",
  },
];

export { questions, domainData };
